module.exports = __webpack_public_path__ + "img/bg_3.7612837b.jpg";